import * as React from "react";

interface PrimaryActionProps {
  name: string;
  disabled?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  children: React.ReactNode;
}

export const ActionPrimary: React.FunctionComponent<PrimaryActionProps> = (
  props
) => {
  return (
    <button
      type="submit"
      className={`form-action-primary ${props.name}-button ${
        props.disabled ? "pretend-disabled" : "enabled"
      }`}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
};
